import PropTypes from 'prop-types'
import { FETCH_ORDER_ERRORS_COUNT } from '../actions/types'

/** @typedef {number} OrderErrorsCountState */

export const orderErrorsCountPropTypes = PropTypes.number

/**
 * initial state for order errors count slice
 * @type {OrderErrorsCountState}
 */
const initialState = 0

/**
 * reducer to manage order errors count state.
 * @param {OrderErrorsCountState} state
 * @param {{ type: string, payload: OrderErrorsCountState }} action
 */
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_ORDER_ERRORS_COUNT:
      return payload
    default:
      return state
  }
}
